<template>
	<div class="content">
		<!-- 添加分类 -->
		<a-button class="mb-15" type="primary" @click="add">
		  添加菜单
		</a-button>
		<!-- 表格 -->
		<Table 
		:columns="columns" 
		:datasource="datasource" 
		:pagination="pagination"
		@gettabledata="gettabledata" 
		@getshow = "getshow"
		@modify = "modify"
		@del = "del"
		@sortmenu="sortmenu"
		@savemenu = "savemenu"
		@changemenu = "changemenu"
		@cancelmenu = "cancelmenu"
		>
		</Table>
		
		<!-- 修改 -->
		<Modify ref="modify" :record="record" @gettabledata="gettabledata"  @changeimg = "changeimg" @modifynav="modifynav"></Modify>
		
		<!-- Add -->
		<Add ref="add" :record="record" @changeimg = "changeimg" @modifynav="addnav"></Add>
	</div>
</template>

<script>
	import {mapState,mapGetters,mapMutations,mapActions} from "vuex";
	import Table from "../../components/nvmenu/table.vue"
	import Modify from "../../components/nvmenu/modify.vue"
	import Add from "../../components/nvmenu/add.vue"
	export default {
		components:{
			Table,
			Modify,
			Add
		},
		data() {
			return {
				cacheData:"",
				editingKey:"",
				record:{
					data:"",
					shop:"",
					classify:""
				},
				pagination:{
					pageSize:10,
					current:1,
					totalPage:0,
					total:0,
					keyword:"",
					platform:""
				},
				columns :[
				  {
				    title: '排序',
				    dataIndex: 'sort',
					key:"sort",
				    sorter: true,
				    width: '5%',
				    scopedSlots: { customRender: 'sort' },
					 align: 'center' 
				  },
				  {
				    title: 'ID',
					key:"id",
				    dataIndex: 'id',
					 align: 'center' 
				  },
				  {
				    title: '名称',
					key:"name",
				    dataIndex: 'name',
					 align: 'center' 
				  },
				  {
				    title: '类型',
					key:"type",
				    dataIndex: 'type',
					 align: 'center' 
				  },
				  {
				    title: 'ICON',
				  	key:"icon",
				    dataIndex: 'icon',
					slots: { title: 'icon' }, //插槽列
					scopedSlots: { customRender: "icon" },//插槽列数据
					 align: 'center' 
				  },
				  {
				    title: '是否显示',
					key:"status",
					dataIndex: 'status',
					slots: { title: 'status' }, //插槽列
					scopedSlots: { customRender: "status" },//插槽列数据
					 align: 'center' 
				  },
				  {
				    title: '创建时间',
					key:"create_time",
				    dataIndex: 'create_time',
					 align: 'center' 
				  },
				  {
				    title: '创建人',
					key:"create_user",
				    dataIndex: 'create_user',
					 align: 'center' 
				  },
				  {
				    title: '操作',
					key:"action",
				    dataIndex: 'action',
					slots: { title: 'action' }, //插槽列
					scopedSlots: { customRender: "action" },//插槽列数据
					 align: 'center' 
				  },
				],
				datasource:[
					{
						sort:1,
						id:1,
						name:"家电清洗",
						classify:"服务",
						icon:"icon",
						show:false,
						time:"2012-03-34",
						person:"马先生",
						control:"修改"
					}
				]
			}
		},
		created() {
			this.gettabledata(this.pagination)
		},
		methods:{
			...mapActions({
				getnav:"appletsetnavmenu/getnav",
				getstatus:"appletsetnavmenu/getstatus",
				getupdate:"appletsetnavmenu/getupdate",
				getadd:"appletsetnavmenu/getadd",
				getdel:"appletsetnavmenu/getdel",
				commone:"index/commone",
				getallclass:"index/getallclass",
				getsort:"appletsetnavmenu/getsort"
			}),
			/*
			 *获取数据
			 *pagination 分页参数
			 * 初始化和点击执行
			 */
			async gettabledata(pagination){
				 let data = await this.getnav(pagination)
				 console.log(data,"数据");
				 this.pagination.current = pagination.current
				 this.pagination.total = data.data.total
				 this.pagination.totalPage = data.data.totalPage
				 this.datasource = data.data.data
			
			},
			
			// 显示和禁止
			async getshow(id){
				let msg = await this.getstatus(id)
				this.$message.success(msg)
				//刷新数据
				this.gettabledata(this.pagination)
			},
			
			// 打开修改弹窗
			async modify(record){
				let shop = await this.commone('all_service')
				let classify = await this.getallclass('two_category')
				console.log("所有服务",shop);
				console.log("所有分类",classify);
				console.log("record",record);
				
				// 每一行数据record
				this.record.data = record
				this.record.shop = shop
				// classify.shift()
				this.record.classify = classify
				this.$refs.modify.show = true
				
			},
			// 排序
			sortmenu(key){
				const newData = [...this.datasource];
				const target = newData.filter(item => key === item.sort)[0];
				this.editingKey = key;
				if (target) {
				  target.editable = true;
				  this.datasource = newData;
				}
			},
			// 保存排序
			async savemenu(key){
				const newData = [...this.datasource];
				this.cacheData = this.datasource.map(item => ({ ...item }));
				const newCacheData = [...this.cacheData];
				const target = newData.filter(item => key === item.sort)[0];
				console.log(target,"目标元素");
				let payload = {
					id:target.id,
					value:target.sort
				}
				let msg = await this.getsort(payload)
				this.$message.success(msg)
				//刷新数据
				await this.gettabledata(this.pagination)
				const targetCache = newCacheData.filter(item => key === item.sort)[0];
				if (target && targetCache) {
				  delete target.editable;
				  this.datasource = newData;
				  Object.assign(targetCache, target);
				  this.cacheData = newCacheData;
				}
				
				this.editingKey = '';
			},
			changemenu(key){
				// console.log(key,"变化值");
				const newData = [...this.datasource];
				const target = newData.filter(item => key.key === item.sort)[0];
				if (target) {
				  target[key.column] = key.value;
				  this.datasource = newData;
				}
			},
			cancelmenu(key){
				const newData = [...this.datasource];
				this.cacheData = this.datasource.map(item => ({ ...item }));
				const target = newData.filter(item => key === item.sort)[0];
				this.editingKey = '';
				if (target) {
				  Object.assign(target, this.cacheData.filter(item => key === item.sort)[0]);
				  delete target.editable;
				  this.datasource = newData;
				}
			},
			// 打开添加弹窗
			async add(){
				let shop = await this.commone('all_service')
				let classify = await this.getallclass('two_category')
				console.log("所有服务",shop);
				console.log("所有分类",classify);
				console.log("record",record);
				// 每一行数据record
				let record = {
					name:"",
					icon:"",
					type:"",
					type_id:"",
					banner:""
				}
				this.record.data = record
				this.record.shop = shop
				// classify.shift()
				this.record.classify = classify
				this.$refs.add.show = true
				
			},
			// 更换图片
			changeimg(payload){
				console.log("payload",payload);
				if(payload.witchbtn ==1){
					this.record.data.icon = payload.val
				}
				else{
					this.record.data.banner = payload.val
				}
				
			},
			// 修改提交
			async modifynav(payload){
				console.log(payload,"提交参数");
				let msg = await this.getupdate(payload)
				this.$message.success(msg)
				//刷新数据
				await this.gettabledata(this.pagination)
				this.$refs.modify.show = false
			},
			// 打开
			// addnav 添加提交
			async addnav(payload){
				console.log(payload,"提交参数");
				let msg = await this.getadd(payload)
				this.$message.success(msg)
				await this.gettabledata(this.pagination)
				this.$refs.add.show = false
			},
			// 删除
			async del(e){
				// 
				console.log(e);
				let msg = await this.getdel(e.id)
				this.$message.success(msg)
				this.gettabledata(this.pagination)
			}
		}
	}
</script>

<style>
</style>
